"use client";

import Image from "next/image";
import { useState } from "react";
import "./collapsible-row.scss";
import CaretDownIcon from "./images/caretdown.svg";
import CaretUpIcon from "./images/caretup.svg";

interface Props {
  collapsedTitle: string;
  expandedTitle: string;
  children: React.ReactNode;
}

export default function CollapsibleRow({
  collapsedTitle,
  expandedTitle,
  children,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <tr className={`moreInfoRow ${isOpen ? "expanded" : ""}`}>
      <td colSpan={5}>
        <button
          className="moreInfoToggle"
          aria-label={isOpen ? expandedTitle : collapsedTitle}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="sectionTitle">
            <div className="imageWrapper">
              <Image
                src={isOpen ? CaretUpIcon : CaretDownIcon}
                alt=""
                width={16}
                height={16}
              />
            </div>
            <span>{isOpen ? expandedTitle : collapsedTitle}</span>
          </div>
        </button>
        <div
          className="moreInfoContainer"
          style={{ display: isOpen ? "block" : "none" }}
        >
          {children}
        </div>
      </td>
    </tr>
  );
}
